// extracted by mini-css-extract-plugin
module.exports = {"main":"_404-module--main--1GCBj"};